import { render, staticRenderFns } from "./mainMenu.vue?vue&type=template&id=35f9b12b&scoped=true"
import script from "./mainMenu.vue?vue&type=script&lang=js"
export * from "./mainMenu.vue?vue&type=script&lang=js"
import style0 from "./mainMenu.vue?vue&type=style&index=0&id=35f9b12b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f9b12b",
  null
  
)

export default component.exports